import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import Certificates from '@features/supplier/component/Certificates';
import CoverPhoto from '@features/supplier/component/CoverPhoto';
import Gallery from '@features/supplier/component/Gallery';
import KeyCustomers from '@features/supplier/component/KeyCustomers';
import KeyProducts from '@features/supplier/component/KeyProducts';
import Other from '@features/supplier/component/Other';
import ProductionCapacity from '@features/supplier/component/ProductionCapacity';
import QuickInfo from '@features/supplier/component/QuickInfo';
import Relation from '@features/supplier/component/Relation';
import SafetyInformation from '@features/supplier/component/SafetyInformation';
import Technical from '@features/supplier/component/Technical';
import AssessmentDocuments from '@features/supplier/component/AssessmentDocuments';
import RegulatoryDocuments from '@features/supplier/component/RegulatoryDocuments';
import AuditReports from '@features/supplier/component/AuditReports';
import AdditionalDocuments from '@features/supplier/component/AdditionalDocuments';
import StrengthSummary from '@features/supplier/component/StrengthSummary';

import { getSuppliersDetails } from '@store/reducers';
import { fetchSupplierDetails, fetchSuppliersCertificates } from '@store/supplier/action';

import { getSupplierDocuments } from '@services/supplierOnboardingService';

import DevelopedProducts from '@/features/supplier/component/DevelopedProducts';

const SupplierDetails = () => {
	const [activeStep, setActiveStep] = useState('info');
	const dispatch = useDispatch();
	const { id } = useParams();

	const supplierDetails = useSelector(getSuppliersDetails);
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(fetchSupplierDetails(id));
		dispatch(fetchSuppliersCertificates(id));
		dispatch(getSupplierDocuments(id));
		return () => {
			dispatch({
				type: 'FETCH_SUPPLIER_DETAILS_SUCCESS',
				payload: null
			});
		};
	}, [dispatch, id]);

	const handleTabChange = (tabId) => {
		setActiveStep(tabId);
		// window.scrollTo({ top: 35, behavior: 'smooth' });
	};

	const tabComponents = {
		info: (
			<>
				<CoverPhoto detailsInfo={supplierDetails} />
				<StrengthSummary detailsInfo={supplierDetails} />
				<QuickInfo detailsInfo={supplierDetails} />
				<Certificates />
				<AssessmentDocuments />
				<RegulatoryDocuments />
				<AuditReports />
				<AdditionalDocuments />
			</>
		),
		customer: <KeyCustomers detailsInfo={supplierDetails} />,
		developedProducts: <DevelopedProducts detailsInfo={supplierDetails} />,
		production: <ProductionCapacity supplierInfo={supplierDetails} />,
		relation: <Relation />,
		products: <KeyProducts supplierInfo={supplierDetails} />,
		technical: <Technical />,
		gallery: <Gallery />,
		safety: <SafetyInformation detailsInfo={supplierDetails} />,
		other: <Other detailsInfo={supplierDetails} />
	};

	return (
		<>
			<div className="top-header">
				<div className="page-title-area bg-white d-flex align-items-center">
					<img
						src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`}
						alt="back"
						className="cursor-pointer"
						onClick={() => navigate('/suppliers/view')}
					/>
					<h1 className="semibold-18 ml-2">{supplierDetails?.name}</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp bg-white">
					<div className="container-fluid px-0">
						<div className="row">
							<div className="col-md-12">
								<ul className="supplier-section-nav">
									{[
										{ id: 'info', label: 'Quick info' },
										{ id: 'customer', label: 'Key Customers' },
										{ id: 'developedProducts', label: 'Developed Products' },
										{ id: 'production', label: 'Production Capacity' },
										{ id: 'relation', label: 'Relation with nitex' },
										{ id: 'products', label: 'Key Products' },
										{ id: 'certificate', label: 'Compliance' },
										{ id: 'technical', label: 'Technical' },
										{ id: 'gallery', label: 'Gallery' },
										{ id: 'safety', label: 'Safety Information' },
										{ id: 'other', label: 'Other Information' }
									].map((tab) => (
										<li key={tab.id} className={activeStep === tab.id ? 'active' : ''}>
											<a href={`#${tab.id}`} onClick={() => handleTabChange(tab.id)}>
												{tab.label}
											</a>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="supplier-all-content">
				{Object.keys(tabComponents).map((tabId) => (
					<div key={tabId} id={tabId}>
						{tabComponents[tabId]}
					</div>
				))}
			</div>
		</>
	);
};

export default SupplierDetails;
